(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fl-product-grid"] && !Shopify.designMode) return;
  try {
    /* Client-side filter + sort over the rendered grid. Shared by fl-collection
     and fl-search; emitted once. Operates on the single .fl-plp on the page. */
  (function () {
    var root = document.querySelector('.fl-plp');
    if (!root) return;
    var grid = root.querySelector('[data-plp-grid]');
    var chipsWrap = root.querySelector('[data-filter-chips]');
    var sortSel = root.querySelector('[data-sort]');
    var countEl = root.querySelector('[data-plp-count]');
    var emptyEl = root.querySelector('[data-plp-empty]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.children);
    var original = cards.slice();
    var activeFilter = 'all';

    function applyFilter() {
      var shown = 0;
      cards.forEach(function (c) {
        var match = activeFilter === 'all' || c.getAttribute('data-type') === activeFilter;
        c.hidden = !match;
        if (match) shown++;
      });
      if (countEl) countEl.textContent = String(shown);
      if (emptyEl) emptyEl.hidden = shown > 0;
    }
    function applySort() {
      var v = sortSel ? sortSel.value : 'featured';
      var arr = original.slice();
      if (v === 'price-asc') arr.sort(function (a, b) { return (+a.getAttribute('data-price')) - (+b.getAttribute('data-price')); });
      else if (v === 'price-desc') arr.sort(function (a, b) { return (+b.getAttribute('data-price')) - (+a.getAttribute('data-price')); });
      else if (v === 'name') arr.sort(function (a, b) { return (a.getAttribute('data-name') || '').localeCompare(b.getAttribute('data-name') || ''); });
      arr.forEach(function (c) { grid.appendChild(c); });
    }

    if (chipsWrap) chipsWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      chipsWrap.querySelectorAll('.chip').forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
      btn.classList.add('is-active'); btn.setAttribute('aria-pressed', 'true');
      activeFilter = btn.getAttribute('data-filter');
      applyFilter();
    });
    if (emptyEl) emptyEl.addEventListener('click', function (e) {
      var clear = e.target.closest('[data-clear-filter]');
      if (!clear) return;
      e.preventDefault();
      activeFilter = 'all';
      if (chipsWrap) chipsWrap.querySelectorAll('.chip').forEach(function (b) {
        var on = b.getAttribute('data-filter') === 'all';
        b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      applyFilter();
    });
    if (sortSel) sortSel.addEventListener('change', applySort);
  })();
  } catch(e) { console.error(e); }
})();

})();
